<!-- TrainingInstitutionDetail.vue -->
<template>
        <myDialog 
            :isDialog="dialogVisible" 
            :title="title" 
            :width="'1200px'"
            @handleClose="handleClose"
        >
            <template slot="content">
                <!-- 详情内容区域 -->
                <div class="detail-content" v-if="detailData">
                    <!-- 基本信息 -->
                    <div class="section-container">
                        <div class="section-header">基本信息</div>
                        <el-descriptions 
                            :column="2" 
                            border
                            size="medium"
                            class="detail-descriptions"
                        >
                            <el-descriptions-item label="统一社会信用代码">
                                {{ detailData.institutionId || '-' }}
                            </el-descriptions-item>
                            <el-descriptions-item label="机构名称">
                                {{ detailData.institutionName || '-' }}
                            </el-descriptions-item>
                            <el-descriptions-item label="联系人">
                                {{ detailData.contactPerson || '-' }}
                            </el-descriptions-item>
                            <el-descriptions-item label="联系电话">
                                {{ detailData.contactPhone || '-' }}
                            </el-descriptions-item>
                            <el-descriptions-item label="法人代表">
                                {{ detailData.legalRepresentative || '-' }}
                            </el-descriptions-item>
                            <el-descriptions-item label="所属区域">
                                {{ detailData.districtName || '-' }}
                            </el-descriptions-item>
                            <el-descriptions-item label="机构地址" :span="2">
                                {{ detailData.address || '-' }}
                            </el-descriptions-item>
                            <el-descriptions-item label="机构类型">
                                {{ detailData.institutionType || '-' }}
                            </el-descriptions-item>
                            <el-descriptions-item label="信用等级">
                                <span v-if="detailData.creditLevel">
                                    <img 
                                        v-if="getIntegrityGradeIcon(detailData.creditLevel)" 
                                        :src="getIntegrityGradeIconSrc(detailData.creditLevel)"
                                        style="width: 20px; height: 20px; vertical-align: middle; margin-right: 5px;"
                                        alt=""
                                    />
                                </span>
                                <span v-else>-</span>
                            </el-descriptions-item>
                            <el-descriptions-item label="许可证号">
                                {{ detailData.licenseNumber || '-' }}
                            </el-descriptions-item>
                            <el-descriptions-item label="许可证到期日">
                                {{ formatDate(detailData.licenseExpiryDate) || '-' }}
                            </el-descriptions-item>
                            <el-descriptions-item label="举办单位/举办者">
                                {{ detailData.sponsor || '-' }}
                            </el-descriptions-item>
                            <el-descriptions-item label="审批机关">
                                {{ detailData.approvalOrg || '-' }}
                            </el-descriptions-item>
                        </el-descriptions>
                    </div>

                    <!-- 银行账户信息 -->
                    <div class="section-container">
                        <div class="section-header">银行账户信息</div>
                        <div v-if="detailData.accountName || detailData.bankName || detailData.bankAccount" class="bank-account-section">
                            <div class="bank-account-item">
                                <div class="bank-account-title">学杂费存取专户</div>
                                <el-descriptions 
                                    :column="1" 
                                    border
                                    size="medium"
                                    class="bank-descriptions"
                                >
                                    <el-descriptions-item label="账户名称">
                                        {{ detailData.accountName || '-' }}
                                    </el-descriptions-item>
                                    <el-descriptions-item label="开户银行">
                                        {{ detailData.bankName || '-' }}
                                    </el-descriptions-item>
                                    <el-descriptions-item label="银行账号">
                                        {{ detailData.bankAccount || '-' }}
                                    </el-descriptions-item>
                                </el-descriptions>
                            </div>
                        </div>
                        <div v-else class="no-bank-data">
                            <span>-</span>
                        </div>
                    </div>

                    <!-- 人员信息 -->
                    <div class="section-container">
                        <div class="section-header">人员信息</div>
                        <el-descriptions 
                            :column="2" 
                            border
                            size="medium"
                            class="detail-descriptions"
                        >
                            <el-descriptions-item label="校长姓名">
                                {{ detailData.principalName || '-' }}
                            </el-descriptions-item>
                            <el-descriptions-item label="校长身份证号">
                                {{ detailData.principalIdCard || '-' }}
                            </el-descriptions-item>
                            <el-descriptions-item label="院长姓名">
                                {{ detailData.deanName || '-' }}
                            </el-descriptions-item>
                            <el-descriptions-item label="院长身份证号">
                                {{ detailData.deanIdCard || '-' }}
                            </el-descriptions-item>
                        </el-descriptions>
                    </div>
                </div>
                
                <!-- 加载状态 -->
                <div v-else-if="loading" class="loading-container">
                    <el-skeleton animated>
                        <template #template>
                            <el-skeleton-item variant="text" style="width: 30%" />
                            <el-skeleton-item variant="text" style="width: 40%; margin-left: 24px;" />
                            <el-skeleton-item variant="text" style="width: 35%" />
                        </template>
                    </el-skeleton>
                </div>
                
                <!-- 无数据状态 -->
                <div v-else class="no-data">
                    <el-empty description="暂无数据" />
                </div>
            </template>
            
            <!-- 底部按钮（可选） -->
            <template slot="footer">
                <div class="dialog-footer">
                    <el-button @click="handleClose">关闭</el-button>
                    <!-- 可以添加其他操作按钮 -->
                    <!-- <el-button type="primary" @click="handleEdit">编辑</el-button> -->
                </div>
            </template>
        </myDialog>
</template>

<script>
import '@/assets/css/base.css'
import { getTrainingInstitutionDetail } from '@/api/training'
export default {
    name: 'TrainingInstitutionDetail',
    props: {
        isDialog: {
            type: [String, Boolean],
            default: false
        },
        title: {
            type: String,
            default: ''
        },
        institutionId:{
            type: String,
            default:""
        }
    },
    data() {
        return {
            dialogVisible: false, // 控制弹窗显示
            detailData: {},     // 详情数据
            loading: false,       // 加载状态
        }
    },
    methods: {
        // 打开弹窗
        openDialog(row) {
            this.dialogVisible = true
            // 优先使用传入的 row 参数中的 institutionId，如果没有则使用 props
            const id = (row && row.institutionId) ? row.institutionId : this.institutionId
            if (id) {
                this.loadDetailData(id)
            } else {
                // 如果没有 id，等待 props 更新后再加载
                this.$nextTick(() => {
                    if (this.institutionId) {
                        this.loadDetailData(this.institutionId)
                    }
                })
            }
        },
        
        // 关闭弹窗
        handleClose() {
            this.dialogVisible = false
            this.detailData = null
            this.currentRowId = null
            // 可以通知父组件弹窗已关闭
            this.$emit('dialog-closed')
        },
        
        // 从接口加载详情数据（如果需要）
        async loadDetailData(institutionId) {
            if (!institutionId) {
                this.loading = false
                return
            }
            this.loading = true
            try {
                const res = await getTrainingInstitutionDetail({ institutionId })
                if (res.code === 200) {
                    this.detailData = res.data
                }
            } catch (error) {
                console.error('加载详情失败:', error)
            } finally {
                this.loading = false
            }
        },
        
        // 复制父组件的诚信等级图标方法
        getIntegrityGradeIcon(gradeName) {
            if (!gradeName) return ''
            const upperName = String(gradeName).toUpperCase()
            if (upperName.includes('A')) {
                return 'rankA'
            } else if (upperName.includes('B')) {
                return 'rankB'
            } else if (upperName.includes('C')) {
                return 'rankC'
            }
            return ''
        },
        
        // 获取图标路径
        getIntegrityGradeIconSrc(gradeName) {
            const iconName = this.getIntegrityGradeIcon(gradeName)
            if (!iconName) return ''
            return require(`@/assets/images/custom-icons/${iconName}.svg`)
        },
        
        // 格式化日期 (从 YYYYMMDD 格式转换为 YYYY-MM-DD)
        formatDate(dateStr) {
            if (!dateStr) return '-'
            // 如果是 YYYYMMDD 格式，转换为 YYYY-MM-DD
            if (dateStr.length === 8 && /^\d+$/.test(dateStr)) {
                return `${dateStr.substring(0, 4)}-${dateStr.substring(4, 6)}-${dateStr.substring(6, 8)}`
            }
            return dateStr
        }
    },
    // 监听父组件传递的isDialog变化（如果使用props控制）
    watch: {
        isDialog: {
            handler(newVal) {
                // 如果isDialog是Boolean类型
                if (typeof newVal === 'boolean') {
                    this.dialogVisible = newVal
                }
                // 如果isDialog是String类型（例如："true-机构基本信息"）
                else if (typeof newVal === 'string') {
                    this.dialogVisible = newVal.includes('true')
                }
            },
            immediate: true
        }
    }
}
</script>


<style lang="scss" scoped>
.myDialog {
    /deep/ .el-dialog__header {
        height: 48px;
        line-height: 48px;
        font-size: 17px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: var(--vt-c-blue)!important;
    }
            
    /deep/ .el-dialog__title {
        color: #ffffff !important;
        font-weight: 700;
        font-size: 17px;
    }
            
    /deep/ .el-dialog__headerbtn {
        filter: brightness(0) invert(1) !important;
    }
}

.detail-content {
    padding: 20px;
    
    .section-container {
        margin-bottom: 24px;
        
        &:last-child {
            margin-bottom: 0;
        }
        
        .section-header {
            display: flex;
            align-items: center;
            height: 40px;
            margin-bottom: 16px;
            
            &::before {
                content: '';
                width: 3px;
                height: 12px;
                background: var(--vt-c-blue-soft);
                margin-right: 8px;
            }
            
            &::after {
                content: '';
                flex: 1;
                height: 1px;
                border-top: 1px dashed #d3d4d6;
                margin-left: 8px;
            }
        }
        
        .detail-descriptions {
            /deep/ .el-descriptions__label {
                font-weight: 500;
                color: #606266;
                background: var(--vt-c-grey-mute);
            }
            
            /deep/ .el-descriptions__content {
                color: #303133;
            }
        }
        
        .bank-account-section {
            .bank-account-item {
                margin-bottom: 16px;
                
                &:last-child {
                    margin-bottom: 0;
                }
                
                .bank-account-title {
                    width: 137px;
                    height: 36px;
                    line-height: 36px;
                    background: var(--vt-c-blue);
                    color: #ffffff;
                    font-weight: 600;
                    font-size: 14px;
                    padding: 0 16px;
                    border-radius: 0px 43px 0px 0px;
                    border: 1px solid #e9eaec;
                    margin-bottom: 0;
                }
                
                .bank-descriptions {
                    margin-top: 0;
                    
                    /deep/ .el-descriptions__table {
                        border: 1px solid #e9eaec;
                        border-top: none;
                        border-radius: 0 0 4px 4px;
                    }
                    
                    /deep/ .el-descriptions__label {
                        font-weight: 500;
                        color: #606266;
                        background-color: var(--vt-c-grey-mute)
                    }
                    
                    /deep/ .el-descriptions__content {
                        color: #303133;
                        background-color: #ffffff;
                    }
                }
            }
        }
        
        .no-bank-data {
            padding: 20px;
            text-align: center;
            color: #909399;
        }
    }
}
</style>
    